export class ReqPromise<T = any> {
	public readonly promise: Promise<T>;
	public readonly resolve: (res: T) => void;
	public readonly reject: (err: any) => void;

	constructor(public readonly reqId: number) {
		let res: any, rej: any;
		this.promise = new Promise((resolve, reject) => {
			res = resolve;
			rej = reject;
		});
		this.resolve = res;
		this.reject = rej;
	}
}
